import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ActivityType from '../../entities/activityType';
import Task from '../../entities/task';
import TemplateTask from '../../entities/templateTask';
export function deleteActivityType(activityType: ActivityType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityType.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('activityTypeId', activityType.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.activityTypeIds = _task.activityTypeIds?.filter(id => id !== activityType.id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().templateTasks.getMappingFor('activityTypeIds', activityType.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.activityTypeIds = _templateTask.activityTypeIds?.filter(id => id !== activityType.id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



activityType.status = 'D';
activityType.addedOn = newHRTimestamp();
activityType.addedBy = getCurrentUserId();
activityType.importSource = targetImportSource;
activityType.importId = mergeId;
store.dispatch(Actions.ActivityTypeActions.removeActivityTypeQueue(activityType));
}
export function replaceActivityType(activityType: ActivityType, replaceWith: ActivityType, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = activityType.id;}
const _work = workingSet();
store.getState().tasks.getMappingFor('activityTypeId', activityType.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_task.activityTypeIds = _task.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];

_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().templateTasks.getMappingFor('activityTypeIds', activityType.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.activityTypeIds = _templateTask.activityTypeIds?.map(id => (id === activityType.id) ? replaceWith.id : id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



return activityType;
}
export function deleteImpactActivityType(activityType: ActivityType) {
const impacts: string[] = [];
const state = store.getState();
const taskActivityTypeIdsImpact = state.tasks.getMappingFor('activityTypeId', activityType.id).filter(task => task.status !== 'D');
taskActivityTypeIdsImpact.forEach(() => impacts.push('tasks'));
const templateTaskActivityTypeIdsImpact = state.templateTasks.getMappingFor('activityTypeIds', activityType.id).filter(templateTask => templateTask.status !== 'D');
templateTaskActivityTypeIdsImpact.forEach(() => impacts.push('templateTasks'));



return util.countDistinct(impacts);
}
